import { AuthService } from '@app/auth.service';
var UserService = /** @class */ (function () {
    function UserService(Auth) {
        this.Auth = Auth;
    }
    UserService.prototype.isLoggedIn = function () {
        var result = {
            status: false
        };
        var member_info = JSON.parse(sessionStorage.getItem('member_obj'));
        if (member_info != null) {
            if (member_info.member_no != '') {
                result.status = true;
            }
        }
        return result;
    };
    UserService.prototype.logout = function () {
        localStorage.setItem('dpa_portal', null);
        this.Auth.setLoggedIn(false);
        var result = {
            status: true
        };
        return result;
    };
    return UserService;
}());
export { UserService };



// WEBPACK FOOTER //
// ./src/app/user.service.ts.pre-build-optimizer.js